/** @jsxImportSource @emotion/react */
import { useEffect, useId, useState } from "react";
import PropTypes from "prop-types";
import { gotoLabelCss, inputCss } from "./index.css";

export default function JumpToPage({ currentPage, lastPage, onChangePage, disabled }) {
  const inputId = useId();
  const [input, setInput] = useState(currentPage + 1);
  const [error, setError] = useState(false);

  const onChange = ({ target }) => {
    setError(false);

    const { value } = target;
    const valueAsNumber = parseInt(value, 10);

    if (Number.isNaN(valueAsNumber)) {
      setError(true);

      setInput(value);

      return;
    }

    setError(valueAsNumber < 0 || valueAsNumber > lastPage);
    setInput(valueAsNumber);
  };

  const submit = () => {
    if (error || input === currentPage + 1) return;

    onChangePage(input - 1);
  };

  const onKeyDown = (event) => {
    if (event.code !== "Enter") return;

    submit();
  };

  useEffect(() => {
    setInput(currentPage + 1);
    setError(false);
  }, [currentPage]);

  return (
    <label htmlFor={inputId} css={gotoLabelCss} className="text">
      <span>Jump to page</span>

      <input
        id={inputId}
        type="text"
        css={inputCss({ error })}
        value={input}
        onChange={onChange}
        onBlur={submit}
        onKeyDown={onKeyDown}
        disabled={disabled}
      />
    </label>
  );
}

JumpToPage.propTypes = {
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
